import React, { useState, useEffect, useRef } from 'react';
// import './HeroSlider.css';

const HeroSlider = () => {
    const [currentIndex, setCurrentIndex] = useState(2); // Set initial center focus
    const autoPlayRef = useRef(null);

    const portfolioItems = [
        {
            title: "Pre-Wedding & Wedding",
            img: "/services/wedding.jpg"
        },
        {
            title: "Modeling & Acting",
            img: "/services/modeling.jpg"
        },
        {
            title: "Fashion & Beauty",
            img: "/services/fashion.jpg"
        },
        {
            title: "Product & Brand",
            img: "/services/product.jpg"
        },
        {
            title: "Commercial & Industrial",
            img: "/services/commercial.jpg"
        },
        {
            title: "Creative & Fine Art",
            img: "/services/creative.jpg"
        },
        {
            title: "Celebrity & Movie Poster",
            img: "/services/celebrity.jpg"
        }
    ];

    const nextSlide = () => {
        setCurrentIndex((prev) => (prev + 1) % portfolioItems.length);
    };

    const prevSlide = () => {
        setCurrentIndex((prev) => (prev - 1 + portfolioItems.length) % portfolioItems.length);
    };

    useEffect(() => {
        autoPlayRef.current = setInterval(nextSlide, 4000);
        return () => clearInterval(autoPlayRef.current);
    }, []);

    const resetTimeout = () => {
        if (autoPlayRef.current) {
            clearInterval(autoPlayRef.current);
            autoPlayRef.current = setInterval(nextSlide, 4000);
        }
    };

    const handleCardClick = (index) => {
        setCurrentIndex(index);
        resetTimeout();
    };

    return (
        <section className="snapture-hero-slider">
            {/* Ambient Background Glows */}
            <div className="ambient-glow orange-glow"></div>
            <div className="ambient-glow purple-glow"></div>

            {/* Background Silhouette/Decorations */}
            <div className="photographer-silhouette">
                <img 
                    src="https://images.unsplash.com/photo-1607604276583-eef5d076aa5f?q=80&w=1000" 
                    alt="Photographer Silhouette" 
                    className="silhouette-img"
                />
            </div>

            {/* Top Info Layout */}
             

            {/* Giant Central Typography Title Behind the Camera */}
            <div className="massive-bg-title">
                <h1> Photography Services </h1>
            </div>

            {/* Interactive Camera Device Assembly */}
            <div className="camera-housing-wrapper">
                <div className="camera-body-container">
                    {/* The 3D Camera Body Graphic Structure */}
                    <div className="camera-chassis">
                        <div className="camera-top-dial"></div>
                        <div className="camera-grip"></div>
                        
                        {/* Central Lens Housing */}
                        <div className="camera-lens-outer">
                            <div className="camera-lens-ring">
                                {/* Lens Glass Display serving as active slider frame */}
                                <div className="lens-aperture-glass">
                                    {portfolioItems.map((item, idx) => (
                                        <div 
                                            key={idx}
                                            className={`lens-image-layer ${idx === currentIndex ? 'active' : ''}`}
                                            style={{ backgroundImage: `url(${item.img})` }}
                                        />
                                    ))}
                                    {/* Lens Reflection Coating Overlays */}
                                    <div className="lens-reflection"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Horizontal Continuous Carousel Track at Bottom */}
            <div className="bottom-gallery-tray">
                <div className="tray-scroll-container">
                    {portfolioItems.map((item, idx) => {
                        let positionClass = "side-card";
                        if (idx === currentIndex) positionClass = "center-card-focus";

                        return (
                            <div 
                                key={idx}
                                className={`gallery-tray-card ${positionClass}`}
                                onClick={() => handleCardClick(idx)}
                            >
                                <div 
                                    className="tray-card-bg"
                                    style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.1), rgba(0,0,0,0.7)), url(${item.img})` }}
                                />
                                <div className="tray-card-meta">
                                    <h4 className="tray-card-title">{item.title}</h4>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* Navigation Chevron Buttons */}
            <button className="nav-arrow-btn left-arrow" onClick={() => { prevSlide(); resetTimeout(); }}>
                <i className="fa-solid fa-chevron-left"></i>
            </button>
            <button className="nav-arrow-btn right-arrow" onClick={() => { nextSlide(); resetTimeout(); }}>
                <i className="fa-solid fa-chevron-right"></i>
            </button>
        </section>
    );
};

export default HeroSlider;